import React from "react";
import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-scroll";
import "../index.css";
import logo from "../images/logo3.png";

const Navbar = () => {
  const navs = [
    {
      id: 1,
      title: "Home",
      link: "home",
    },
    {
      id: 2,
      title: "about",
      link: "about",
    },
    // {
    //   id: 3,
    //   title: "projects",
    //   link: "projects",
    // },
    {
      id: 4,
      title: "packages",
      link: "package",
    },
    {
      id: 5,
      title: "blogs",
      link: "blogs",
    },
    {
      id: 6,
      title: "talks",
      link: "talks",
    },
    {
      id: 7,
      title: "contact",
      link: "contact",
    },
  ];

  const [burger, setBurger] = useState(false);

  const handleNav = () => setBurger(!burger);

  return (
    <div className="bg-[#131313] ">
      <div className="w-full h-20 flex justify-between items-center px-4 lg:px-20 ">
        <div className="m-0 p-0">
          <img src={logo} alt="" width={100} className="" />
        </div>

        <div>
          <ul className="hidden md:flex text-gray-100 lowercase font-comfortaa font-semibold">
            {navs.map(({ id, title, link }) => (
              <li
                key={id}
                className="menu pr-6 lg:pr-12 lg:text-lg cursor-pointer hover:text-[#FC5130] hover:scale-105"
              >
                <Link to={link} smooth duration={500}>
                  <p>{title}</p>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Version */}

        <div
          className=" text-white md:hidden cursor-pointer"
          onClick={handleNav}
        >
          {burger ? <AiOutlineClose size={30} /> : <FiMenu size={30} />}
        </div>

        <div
          className={
            burger
              ? "z-10 fixed top-0 left-0 h-screen w-[250px] ease-in-out duration-500"
              : "z-10 fixed top-0 left-0 ml-[-200px] h-screen w-[200px] ease-in-out duration-300 "
          }
        >
          <ul className="glass md:hidden flex flex-col  items-center text-gray-100 uppercase">
            {navs.map(({ id, title, link }) => (
              <li
                key={id}
                className="my-8  text-2xl border-b-2 border-[#FC5130] cursor-pointer"
              >
                <Link
                  onClick={() => setBurger(!burger)}
                  to={link}
                  smooth
                  duration={1000}
                >
                  {link}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
